import React from 'react'
import icon from "../../asstes/images/ic20-edit.png"

export const Información = () => {
  return (
    <div>
        <h2 className='md:text-[64px] md:leading-[81px] text-[32px] mb-5 font-bold leading-[37px]'>Información General</h2>
        <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>Porfavor <span className=' text-red-700'>llena los campos con las letas N/E </span> para terminar el llenado de 
        información general</p>

        <div className='flex items-center justify-between max-w-[700px] mt-6'>
            <div>
                <div className='py-[20px]'>
                    <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>Nombre completo:</p>
                    <div className='flex items-center gap-2'>
                        <img src={icon} alt="" />
                        <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>María José Torrero Heredia</p>
                    </div>
                </div>
                <div className='py-[20px]'>
                    <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>Correo electrónico: </p>
                    <div className='flex items-center gap-2'>
                        <img src={icon} alt="" />
                        <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] text-red-700'>N/E</p>
                    </div>
                </div>
                <div className='py-[20px]'>
                    <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>Contraseña del CIEC:</p>
                    <div className='flex items-center gap-2'>
                        <img src={icon} alt="" />
                        <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] text-red-700'>N/E</p>
                    </div>
                </div>
            </div>
            <div>
                <div className='py-[20px]'>
                    <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>Número celular:</p>
                    <div className='flex items-center gap-2'>
                        <img src={icon} alt="" />
                        <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>+52 811234 5698</p>
                    </div>
                </div>
                <div className='py-[20px]'>
                    <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>RFC: </p>
                    <div className='flex items-center gap-2'>
                        <img src={icon} alt="" />
                        <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] text-red-700'>N/E</p>
                    </div>
                </div>
                <div className='py-[20px]'>
                    <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>Contraseña de E firma:</p>
                    <div className='flex items-center gap-2'>
                        <img src={icon} alt="" />
                        <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] text-red-700'>N/E</p>
                    </div>
                </div>
            </div>
        </div>

        <div className='mt-5'>
            <div className='flex items-center gap-5'>
               <div className='flex items-center gap-2'>
                <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] '>Contraseña de E firma:</p>
                <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] text-red-700'>N/E</p>
               </div>
               <p className='md:text-[24px] md:leading-[29px] text-[14px] leading-[17px] text-red-700'>Cargar archivos</p>
            </div>
            <div className='flex items-center justify-center gap-4 mt-5'>
            <button className='py-4 px-5 bg-[#4285F4] text-white text-[14px] font-medium rounded-md md:text-[24px]'>.KEY</button>
            <button className='py-4 px-5 bg-[#4285F4] text-white text-[14px] font-medium rounded-md md:text-[24px]'>.CER</button>
            </div>
        </div>
    </div>
  )
}
